module.exports = __webpack_public_path__ + "static/media/google_play.1d37d79f.png";